import React from 'react';

const VolumeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 8.5C17.3824 9.17293 19 11.0827 19 12C19 12.9173 17.3824 14.8271 15 15.5M17 5.5C20.6975 6.46702 23 9.42398 23 12C23 14.576 20.6975 17.533 17 18.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 5L6.5 9H3C2.44772 9 2 9.44772 2 10V14C2 14.5523 2.44772 15 3 15H6.5L11 19V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VolumeIcon;
